import {Dropdown, Space, Modal, InputNumber, Row, Col, message} from 'antd';
import {useState} from 'react';
import {splitPlantGroup} from "../../api/Api";

export const PlantDropdownMenu = ({plantId, count, onTransfer, onHarvest, onRefresh, props}) => {
    const [splitModalOpen, setSplitModalOpen] = useState(false);
    const [numTransfer, setNumTransfer] = useState(0);
    const [messageApi, contextHolder] = message.useMessage();

    const items = [
        {
            key: '0',
            label: `Split Group`
        },
        {
            key: '1',
            label: `Transfer`
        }
    ];

    if (onHarvest) {
        items.push({
            key: '2',
            label: `Harvest`
        })
    }

    const onClick = ({key}) => {
        if (key === '0') {
            setSplitModalOpen(true);
        } else if (key === '1') {
            if (onTransfer) onTransfer();
        } else if (key === '2') {
            if (onHarvest) onHarvest();
        }
    }

    const onSplitOk = () => {
        splitPlantGroup(plantId, numTransfer).then(r => {
            messageApi.open({
                type: 'success',
                content: 'plant group split'
            });
            if (onRefresh) onRefresh();
        }).catch(e => {
            console.log(`failed to split plant group`)
            messageApi.open({
                type: 'error',
                content: 'failed to split plant group'
            })
        })
        setSplitModalOpen(false)
    }

    const onSplitCancel = () => {
        setSplitModalOpen(false);
    }

    const onChange = (val) => {
        setNumTransfer(val);
    }

    const rowStyle = {
        marginTop: '5px',
        marginBottom: '5px'
    }

    const okDisabled = (numTransfer <= 0) || (numTransfer >= count);

    return <div>
        {contextHolder}
        <Modal open={splitModalOpen} title={'Split Plant Group'} onOk={onSplitOk} okButtonProps={{disabled: okDisabled}} onCancel={onSplitCancel}>
            <Row style={rowStyle}>
                <Col span={4}>
                    <b># to split:</b>
                </Col>
                <Col>
                    <InputNumber min={0} max={count-1} precision={0} onChange={onChange} value={numTransfer}/>
                </Col>
            </Row>
        </Modal>
        <Dropdown menu={{ items, onClick }}>
            <div style={{cursor: 'pointer', color: "#108ee9"}} onClick={e => e.preventDefault()}>
                <Space>
                    Menu...
                </Space>
            </div>
        </Dropdown>
    </div>
}